import _ from 'lodash';
import { EnabledDynamicCorpParams } from '@scale/shared/corp/dynamicCorpToolManager';
import { useMemo } from 'react';
import { useCachedBackendDefinedCorpPages } from 'corp/hooks/useCachedBackendDefinedCorpPages';
export const useAllDynamicCorpPageTitles = (): { name: string; pageTitle: string }[] => {
  const asyncResult = useCachedBackendDefinedCorpPages();
  return useMemo(() => {
    const syncPageTitles = _.map(EnabledDynamicCorpParams, (params, name) => ({
      name,
      pageTitle: params!.pageTitle,
    }));
    const pageTitles = [...syncPageTitles, ...(asyncResult.value ?? [])].sort((a, b) =>
      a.pageTitle > b.pageTitle ? 1 : -1,
    );
    return pageTitles;
  }, [asyncResult.value]);
};
